<template>
	<div>
		<FITOutstandingRequirement v-bind="properties" :accountType="accountType"></FITOutstandingRequirement>
</div>
</template>
<script type="text/javascript">
import {FITOutstandingRequirement} from '@/components'
import Cookies from 'js-cookie'

	export default{
		name: 'OutstandingRequirement',
		components:{
			FITOutstandingRequirement
		},
		data(){
			return{
				properties:{
					policyType:'G',
					policyID:this.$store.state.GIPolicy.newGI.policyID,
				}
			}
		},
		computed:{
		accountType(){
			// console.log(this.$store.state.role);
      		return this.$store.state.role;
    	  },
		}
	}
</script>


// WEBPACK FOOTER //
// src/Osm/GIPolicy/components/OutstandingRequirement.vue